import React from 'react';
import RaceBracket from './RaceBracket';

const CATEGORY_LABELS = {
  core: 'Core Offices',
  board_of_education: 'Board of Education',
};

const CATEGORY_ORDER = ['core', 'board_of_education'];

const BracketView = ({ races, topParty, filter }) => {
  return (
    <div>
      {CATEGORY_ORDER.map((cat) => {
        const catRaces = races.filter((r) => r.category === cat);
        if (catRaces.length === 0) return null;

        return (
          <div key={cat} className="mb-5">
            <h3 className="text-center mb-3 pb-2 border-bottom">
              {CATEGORY_LABELS[cat]}
            </h3>
            <div className="race-bracket-grid">
              {catRaces
                .filter((race) => {
                  if (filter === 'R') return race.republican.length > 0;
                  if (filter === 'D') return race.democrat.length > 0;
                  return true;
                })
                .map((race) => (
                  <div key={race.id} className="race-bracket-cell">
                    <RaceBracket race={race} topParty={topParty} filter={filter} />
                  </div>
                ))
              }
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default BracketView;
